/**
 * Standar penanganan error request (PWA).
 *
 * - Timeout & gagal koneksi pada request yg MENGUBAH data (POST/PUT/PATCH/DELETE) sudah otomatis
 *   ditampilkan sbg toast oleh axiosInstance (error ditandai `__notified`).
 * - Error lain (4xx/5xx) → panggil `notifyApiError(err)` di catch handler, atau tampilkan sendiri
 *   lewat alert/modal layar dgn `getApiErrorKind` + pesan server.
 */
export type ApiErrorKind = 'timeout' | 'network' | 'tooLarge' | 'server';

export type ToastType = 'error' | 'warning' | 'success' | 'info';
export type ToastDetail = { kind?: ApiErrorKind; message?: string; type?: ToastType };

export const TOAST_EVENT = 'app-toast';

export const getApiErrorKind = (err: any): ApiErrorKind => {
  if (err?.code === 'ECONNABORTED' || err?.code === 'ETIMEDOUT' || /timeout/i.test(err?.message || '')) return 'timeout';
  if (!err?.response) return 'network';
  if (err.response.status === 413 || err.response.data?.code === 'FILE_TOO_LARGE') return 'tooLarge';
  return 'server';
};

/** Pesan dari server (kalau ada) — utk error 4xx/5xx */
export const getServerMessage = (err: any): string | undefined => {
  const m = err?.response?.data?.message || err?.response?.data?.error;
  return typeof m === 'string' && m.trim() ? m : undefined;
};

/** Tampilkan toast global (dirender oleh <GlobalToast/> di App) */
export const showToast = (detail: ToastDetail) => {
  window.dispatchEvent(new CustomEvent<ToastDetail>(TOAST_EVENT, { detail }));
};

/** Tampilkan error request ke user. Tidak dobel kalau interceptor sudah menampilkannya. */
export const notifyApiError = (err: any) => {
  if (err?.__notified) return;
  const kind = getApiErrorKind(err);
  showToast({ kind, message: kind === 'server' ? getServerMessage(err) : undefined, type: 'error' });
  if (err && typeof err === 'object') err.__notified = true;
};
